<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <form @submit="showReport">
          <div class="row">
            <div class="col-md-3">
              <p>Начало периода</p>
              <DateSelect ref="start_date" :selectedDate="periodDates.start"/>
            </div>
            <div class="col-md-3">
              <p>Конец периода</p>
              <DateSelect ref="end_date" :selectedDate="periodDates.end"/>
            </div>
          </div>
          <div class="row p-t-10">
            <div
              class="col-md-4"
              v-if="Object.keys(divisions).length"
            >
              <button type="button" @click="showDivisions = !showDivisions" class="btn btn-default">
                {{ showDivisions ? 'Скрыть' : 'Показать' }} дивизионы
              </button>
            </div>
            <div class="col-md-4">
              Проекты
            </div>
            <div class="col-md-4">
              <div>
                <label for="check_1">
                  <input @change="updateTotalFigures" type="checkbox" class="from-control" v-model="showRUB"
                         id="check_1">
                  показать выторг в RUB
                </label>
                <vue-ladda
                  button-class="btn btn-success"
                  data-style="zoom-in"
                  type="submit"
                  :loading="loading"
                >Показать
                </vue-ladda>
              </div>
            </div>
          </div>
          <div class="division_select_list">
            <div v-for="(division, i) in getSortedDivisions()" v-if="showDivisions && division.id !== '0'">
              <button
                type="button"
                @click="division.selected = !division.selected"
                v-bind:class="{
                    btn: true,
                    'btn-outline-primary': true,
                    active: division.selected
                  }"
              >
                <p class="user"><strong>{{ division?.title ?? 'не определен' }}</strong></p>
                <p class="user">{{ division?.user?.short_name ?? 'не определен' }}</p>
                <p class="stores">
                    <span v-for="(city, i) in division.cities"
                    >{{ i !== 0 ? ", " : "" }}
                      {{
                        city.object_id === 0
                          ? "Почта"
                          : $AllCities[city.object_id].name
                      }}</span
                    >
                  (<span v-for="(store, i) in division.stores"
                >{{
                    i !== 0 ? ", " : ""
                  }}{{ $AllStores[store.object_id].short_title }}</span
                >)
                </p>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="card" v-if="!loading && records && Object.keys(records).length">
      <div class="card-body">
        <div class="overflow-auto p-t-10">
          <table class="table table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th v-for="divId in divisionToDisplay" :key="divId">
                <div class="flex">
                  <div>{{ $AllDivisions[divId]?.title ?? ('не определен ' + divId) }}</div>
                  <template v-if="$AllDivisions[divId].cities.length > 1">
                    <div class="info_block">
                      <v-popover
                        popoverClass=""
                        placement="bottom"
                        trigger="hover"
                      >
                        <i class="icon-fa icon-fa-info info_fa"/>
                        <template slot="popover">
                          <p class="mb-0" v-for="city in $AllDivisions[divId].cities">{{ city.city.short_name }} -
                            <strong>{{
                                (citiesData[city.city.id] && citiesData[city.city.id].total || 0).toLocaleString('ru-RU')
                              }}</strong>
                          </p>
                        </template>
                      </v-popover>
                    </div>
                  </template>
                </div>
              </th>
              <th>Итого</th>
            </tr>
            </thead>
            <thead>
            <tr>
              <td class="p-0">
                <div class="p-1">Общая выручка (за минусом зарплаты)</div>
              </td>
              <td v-for="divId in divisionToDisplay" :key="divId">
                <template v-if="records[divId]">
                  <div>
                    <strong>{{
                        records[divId].total.toLocaleString("ru-RU")
                      }}</strong>
                    <div class="site_sum">
                      <p v-for="(data, siteId) in records[divId].sites">
                        {{ $AllProjects[siteId]?.title ?? 'no title ' + siteId }}:
                        <span v-if="data"
                        >{{
                            Math.round(data.total).toLocaleString("ru-RU")
                          }}
                            ({{
                            Math.round(
                              (data.total * 100) / records[divId].total
                            )
                          }}%)</span
                        >
                        <span v-else>0</span>
                      </p>
                    </div>
                  </div>
                </template>
                <template v-else>
                  no data
                </template>
              </td>
              <td>
                <strong>{{
                    totalData.income.toLocaleString("ru-RU")
                  }}</strong>
                <div class="site_sum">
                  <template v-for="(project, projectId) in $AllProjects">
                    <p v-if="totalData.statBySite[projectId]">
                      {{ project?.title ?? 'no title ' + projectId }}: {{
                        Math.round(totalData.statBySite[projectId].total).toLocaleString('ru-RU')
                      }} ({{ totalData.statBySite[projectId].total_percent }}%)
                    </p>
                  </template>
                </div>
              </td>
            </tr>
            <tr>
              <td class="p-0">
                <div class="p-1">Себестоимость</div>
              </td>
              <td v-for="divId in divisionToDisplay" :key="divId">
                <template v-if="records[divId]">
                  <div>
                    <strong>{{
                        records[divId].total_cost
                          ? records[divId].total_cost.toLocaleString("ru-RU")
                          : 0
                      }}</strong>
                    <div class="site_sum">
                      <p v-for="(data, siteId) in records[divId].sites">
                        {{ $AllProjects[siteId]?.title ?? 'no title ' + siteId }}:
                        <span v-if="data"
                        >{{
                            Math.round(data.cost).toLocaleString("ru-RU")
                          }}
                            ({{
                            Math.round(
                              (data.cost * 100) / records[divId].total_cost
                            )
                          }}%)</span
                        >
                        <span v-else>0</span>
                      </p>
                    </div>
                  </div>
                </template>
                <template v-else>
                  no data
                </template>
              </td>
              <td>
                <strong>{{ totalData.cost.toLocaleString("ru-RU") }}</strong>
                <div class="site_sum">
                  <template v-for="(project, projectId) in $AllProjects">
                    <p v-if="totalData.statBySite[projectId]">
                      {{ project?.title ?? 'no title ' + projectId }}: {{
                        Math.round(totalData.statBySite[projectId].cost).toLocaleString('ru-RU')
                      }} ({{ totalData.statBySite[projectId].cost_percent }}%)
                    </p>
                  </template>
                </div>

              </td>
            </tr>
            <tr>
              <td class="p-0">
                <div class="p-1">Списание препаратов</div>
              </td>
              <td v-for="divId in divisionToDisplay" :key="divId">
                <strong>{{ writeOff[divId] && writeOff[divId].toLocaleString("ru-RU") || 0 }}</strong>
              </td>
              <td>
                <strong>{{ writeOff.total.toLocaleString("ru-RU") }}</strong>
              </td>
            </tr>
            <tr>
              <td class="p-0">
                <div class="p-1">Расходы старшего курьера</div>
              </td>
              <td v-for="divId in divisionToDisplay" :key="divId">
                <template v-if="expenses[divId]">
                  <div>
                    <strong>{{
                        expenses[divId].div.toLocaleString("ru-RU")
                      }}</strong>
                  </div>
                </template>
                <template v-else>
                  0
                </template>
              </td>
              <td>
                <strong>{{
                    expenses.totalDiv.toLocaleString("ru-RU")
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td class="p-0">
                <div class="p-1">Пропорциональная часть общих расходов</div>
              </td>
              <td v-for="divId in divisionToDisplay" :key="divId">
                <strong>{{ (expenses[divId] && expenses[divId].globalPartly || 0).toLocaleString("ru-RU") }}</strong>
              </td>
              <td>
                <strong>{{
                    expenses.totalGlobalPartly.toLocaleString("ru-RU")
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td class="p-0">
                <div class="p-1">Всего расходов</div>
              </td>
              <td v-for="divId in divisionToDisplay" :key="divId">
                <strong>{{
                    ((expenses[divId] && expenses[divId].div || 0) + (expenses[divId] && expenses[divId].globalPartly || 0)).toLocaleString("ru-RU")
                  }}</strong>
              </td>
              <td>
                <strong>{{
                    (
                      expenses.totalDiv + expenses.totalGlobalPartly
                    ).toLocaleString("ru-RU")
                  }}</strong>
              </td>
            </tr>
            <tr>
              <td class="p-0">
                <div class="p-1">ИТОГО прибыль</div>
              </td>
              <td v-for="divId in divisionToDisplay" :key="divId">
                <strong>{{ (expenses[divId] && expenses[divId].profit || 0).toLocaleString("ru-RU") }}</strong>
              </td>
              <td>
                <strong>{{
                    expenses.grandProfit.toLocaleString("ru-RU")
                  }}</strong>
              </td>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";
import DateSelect from "./components/DateSelect";
import VueLadda from "vue-ladda/src/vue-ladda.vue";

export default {
  title: "Отчет за период",
  components: {
    DateSelect,
    VueLadda
  },
  data() {
    return {
      showDivisions: false,
      loading: false,
      showRUB: false,
      records: {},
      projectRate: {},
      expenses: {},
      totalData: {},
      divisions: {},
      writeOff: {},
      citiesData: {},
      divisionToDisplay: [],
      periodDates: {
        start: moment()
          .clone()
          .startOf("month")
          .format("DD.MM.YYYY"),
        end: moment().format("DD.MM.YYYY")
      }
    };
  },
  computed: {
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    },
    $AllProjects() {
      return this.$store.getters["platform/projects"].reduce((acc, p) => {
        acc[p.id] = p;
        return acc;
      }, {});
    },
    $AllStores() {
      return this.$store.getters["platform/stores"];
    },
    $AllCities() {
      return this.$store.getters["platform/cities"];
    }
  },
  mounted() {
    let divisions = {...this.$AllDivisions};
    divisions = {};
    Object.keys(this.$AllDivisions).forEach(divId => {
      divisions[divId] = {...this.$AllDivisions[divId], selected: false};
    });
    this.divisions = divisions;
  },
  methods: {
    getSortedDivisions() {
      return _.orderBy(Object.values(this.divisions), 'title');
    },
    updateTotalFigures() {
      this.totalData = {};

      this.totalData.income = Object.keys(this.records).reduce((acc, k) => {
        if (this.showRUB) {
          acc += this.records[k].total_rub_price;
        } else {
          acc += this.records[k].total;
        }
        return acc;
      }, 0);

      this.totalData.statBySite = Object.keys(this.records).reduce((acc, divId) => {
        if (this.records[divId] && this.records[divId].sites) {
          Object.keys(this.records[divId].sites).forEach((siteId) => {
            if (!acc[siteId]) {
              acc[siteId] = {
                cost: 0,
                total: 0,
                cost_percent: 0,
                total_percent: 0
              };
            }
            if (this.showRUB) {
              acc[siteId].total += this.records[divId].sites[siteId].rub_price;
            } else {
              acc[siteId].total += this.records[divId].sites[siteId].total;
            }
            acc[siteId].cost += this.records[divId].sites[siteId].cost;
          })
        }
        return acc;
      }, {});

      this.totalData.cost = Object.keys(this.records).reduce((acc, k) => {
        acc += this.records[k].total_cost;
        return acc;
      }, 0);

      Object.keys(this.totalData.statBySite).forEach((siteId) => {
        this.totalData.statBySite[siteId].cost_percent = Math.round(this.totalData.statBySite[siteId].cost * 100 / this.totalData.cost);
        this.totalData.statBySite[siteId].total_percent = Math.round(this.totalData.statBySite[siteId].total * 100 / this.totalData.income);
      })

    },
    async showReport(e) {
      e.preventDefault();

      const dateStart = this.$refs.start_date.date;
      const dateEnd = this.$refs.end_date.date;
      if (
        !moment(dateStart, "DD.MM.YYYY").isValid() ||
        !moment(dateEnd, "DD.MM.YYYY").isValid()
      ) {
        toastr["warning"]("Даты не валидные");
        return;
      }

      this.loading = true;
      this.records = {};
      const selectedDivisions = Object.keys(this.divisions).reduce(
        (acc, id) => {
          if (this.divisions[id].selected) {
            acc.push(id);
          }
          return acc;
        },
        []
      );
      if (!selectedDivisions.length) {
        this.divisionToDisplay = Object.keys(this.divisions);
      } else {
        this.divisionToDisplay = [...selectedDivisions];
      }
      const {data} = await api.post("/reports/getReportByPeriod", {
        date: {
          start: dateStart,
          end: dateEnd
        },
        divisions: selectedDivisions
      });

      if (data.success) {
        this.records = data.records;
        this.updateTotalFigures();

        this.projectRate = Object.keys(data.records).reduce((acc, DivId) => {
          acc[DivId] = {
            globalRate: data.records[DivId].total / this.totalData.income,
            projectsRate: data.records[DivId].sites
              ? Object.keys(data.records[DivId].sites).reduce(
                (acc2, projectId) => {
                  acc2[projectId] =
                    data.records[DivId].sites[projectId].total /
                    data.records[DivId].total;
                  return acc2;
                },
                {}
              )
              : {}
          };
          return acc;
        }, {});

        this.writeOff.total = data.writeOffSum;
        this.expenses = Object.keys(this.records).reduce((acc, DivId) => {
          this.writeOff[DivId] =
            +data.writeOffSum * this.projectRate[DivId].globalRate;
          const expense = data.divExpenses[DivId] || 0;
          acc[DivId] = {
            div: expense,
            globalPartly:
              (data.divExpenses[0] || 0) * this.projectRate[DivId].globalRate
          };
          if (!acc.totalDiv) acc.totalDiv = 0;
          acc.totalDiv += acc[DivId].div;
          if (!acc.totalGlobalPartly) acc.totalGlobalPartly = 0;
          acc.totalGlobalPartly += acc[DivId].globalPartly;
          acc[DivId].profit =
            this.records[DivId].total -
            this.records[DivId].total_cost -
            acc[DivId].div -
            acc[DivId].globalPartly -
            this.writeOff[DivId];
          if (!acc.grandProfit) acc.grandProfit = 0;
          acc.grandProfit += acc[DivId].profit;
          return acc;
        }, {});
        this.citiesData = data.citiesData.reduce((acc, c) => {
          acc[c.city_id] = c;
          return acc;
        }, {});

        Object.keys(data.divExpenses).forEach((divId) => {
          if (+divId && !this.expenses[divId]) {
            // const globalPartly = (data.divExpenses[0] || 0) * this.projectRate[divId].globalRate;
            const allExpenses = data.divExpenses[divId];
            this.expenses[divId] = {
              div: allExpenses,
              globalPartly: 0,
              totalDiv: allExpenses,
              totalGlobalPartly: 0,
              profit: 0,
            }
            this.expenses.totalDiv += allExpenses;
            this.expenses.grandProfit -= allExpenses;
          }
        })
        // this.expenses.total = Object.keys(this.expenses).reduce((acc, e) => {
        //   if (e !== 0) {
        //     acc += this.expenses[e];
        //   }
        //   return acc;
        // }, 0);
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>
table tbody td:first-child,
table tbody th:first-child,
table thead td:first-child,
table thead th:first-child {
  position: sticky;
  left: 0;
  background-color: white;
}

table th {
  font-size: 12px;
  word-wrap: normal;
}

table td {
  vertical-align: top;
  font-size: 12px;
}

.site_sum {
  font-size: 8px;
}

p {
  margin-bottom: 2px;
}

.division_select_list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 10px;
}

.division_select_list button {
  font-size: 10px;
  padding: 1px 10px !important;
  min-width: 170px;
  margin-bottom: 2px;
}

.icon-fa {
  font-size: 20px;
  color: #5bbfde;
  cursor: pointer;
}

.info_block {
  display: inline;
  background-color: #5bbfde;
  padding: 0 5px;
  border-radius: 25%;
  margin-left: 5px;
}

.info_block i.icon-fa {
  font-size: 12px;
  color: white;
}
</style>

<style>
.tooltip.popover .popover-inner {
  background: white;
  color: #333;
  padding: 15px;
  text-align: left;
}

.tooltip-inner {
  max-width: 400px;
}

.tooltip {
//max-width: 400px; width: max-content;
}

.popover-inner p {
  margin-bottom: 3px;
}

.popover-inner label {
  font-weight: 600;
}
</style>
